module.exports = __webpack_public_path__ + "static/media/Vector_5.540ccabe.png";